/**
 * Seção "Exames" da janela de dados do risco (#606, E3): em quais tipos de exame o risco entra,
 * as sete caixas em três colunas. Não conta para a completude.
 */

import React from 'react';
import { Box, Button, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { EXAM_TYPES, OCC_EXAM_TYPE_LABELS } from '../../../types/occupationalRisk';
import type { FormularioDoRisco } from '../RiskApplicationModal';

export const SecaoExames: React.FC<{ desabilitada: boolean }> = ({ desabilitada }) => {
  const { control } = useFormContext<FormularioDoRisco>();
  return (
    <Controller
      name="examTypes"
      control={control}
      render={({ field }) => (
        <Stack spacing={1.5}>
          <Stack direction="row" spacing={2} alignItems="center">
            <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>
              Em quais exames este risco entra.
            </Typography>
            <Button type="button" size="small" disabled={desabilitada} onClick={() => field.onChange([...EXAM_TYPES])}>
              Marcar todos
            </Button>
            <Button type="button" size="small" color="inherit" disabled={desabilitada} onClick={() => field.onChange([])}>
              Limpar
            </Button>
          </Stack>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr' }, columnGap: 2 }}>
            {EXAM_TYPES.map((tipo) => (
              <FormControlLabel
                key={tipo}
                label={OCC_EXAM_TYPE_LABELS[tipo]}
                control={
                  <Checkbox
                    checked={field.value.includes(tipo)}
                    disabled={desabilitada}
                    onChange={() =>
                      field.onChange(
                        field.value.includes(tipo) ? field.value.filter((t) => t !== tipo) : [...field.value, tipo],
                      )
                    }
                  />
                }
              />
            ))}
          </Box>
        </Stack>
      )}
    />
  );
};

export default SecaoExames;
